"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _phone = require("@active/core/phone");
var _i18n = require("@active/react-utils/i18n");
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _find = _interopRequireDefault(require("lodash/fp/find"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Menu = _interopRequireDefault(require("../Menu"));
var _MenuHeader = _interopRequireDefault(require("../MenuHeader"));
var _MenuItemList = _interopRequireDefault(require("../MenuItemList"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _MenuSearchInput = _interopRequireDefault(require("../MenuSearchInput"));
var _MenuEmpty = _interopRequireDefault(require("../MenuEmpty"));
var _ComboBox = require("../ComboBox");
var _countries = _interopRequireDefault(require("./countries"));
var DISTANCE = 4;
function findRegionLabel(regionCode) {
  return (0, _compose["default"])((0, _prop["default"])('label'), (0, _find["default"])(function (_ref) {
    var country = _ref.country;
    return country === regionCode;
  }))(_countries["default"]);
}
var FlagSelector = function FlagSelector(_ref2, ref) {
  var _buttonRef$current;
  var disabled = _ref2.disabled,
    _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? 'us' : _ref2$value,
    onBlur = _ref2.onBlur,
    onChange = _ref2.onChange,
    onClick = _ref2.onClick,
    onFocus = _ref2.onFocus,
    menuAutoWidth = _ref2.menuAutoWidth;
  var _useLocale = (0, _i18n.useLocale)(),
    i18n = _useLocale.i18n;
  var buttonElRef = _react["default"].useRef();
  var buttonRef = ref !== null && ref !== void 0 ? ref : buttonElRef;
  var menuRef = _react["default"].useRef(null);
  var regionCode = value === null || value === void 0 ? void 0 : value.toLowerCase();
  var _useSelectOnlyComboBo = (0, _ComboBox.useSelectOnlyComboBox)({
      disabled: disabled,
      comboBoxRef: buttonRef,
      listBoxRef: menuRef,
      onBlur: onBlur,
      onFocus: onFocus
    }),
    expanded = _useSelectOnlyComboBo.expanded,
    collapse = _useSelectOnlyComboBo.collapse;
  var isItemSelected = _react["default"].useCallback(function (country) {
    return country === regionCode;
  }, [regionCode]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
    "aria-controls": "intl-phone-input-flag-listbox",
    "aria-expanded": expanded,
    "aria-label": findRegionLabel(regionCode),
    className: (0, _classnames["default"])('intl-phone-input-country input-group-addon icon-btn', {
      expanded: expanded
    }),
    onClick: onClick,
    ref: buttonRef,
    "data-testid": "flag-selector-button",
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ic-intl-flag ic-intl-flag-".concat(regionCode),
    "data-testid": "intl-phone-input-flag"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-grey-100 mg-l-1",
    "data-testid": "intl-phone-country-code"
  }, "+".concat((0, _phone.countryCodeOf)(regionCode))), /*#__PURE__*/_react["default"].createElement("i", {
    className: "text-grey-90 mg-l-1",
    "aria-hidden": "true"
  })), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    closeOn: "select",
    distance: DISTANCE,
    "data-testid": "intl-phone-input-flag-menu",
    id: "intl-phone-input-flag-listbox",
    focusOnOpen: false,
    isItemSelected: isItemSelected,
    onClose: collapse,
    onItemSelect: onChange,
    open: expanded,
    placement: "bottom-start",
    ref: menuRef,
    refElement: (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.parentElement,
    sameWidth: !menuAutoWidth,
    type: "listbox"
  }, /*#__PURE__*/_react["default"].createElement(_MenuHeader["default"], null, /*#__PURE__*/_react["default"].createElement(_MenuSearchInput["default"], null)), /*#__PURE__*/_react["default"].createElement(_MenuItemList["default"], null, _countries["default"].map(function (_ref3) {
    var country = _ref3.country,
      label = _ref3.label;
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: country,
      value: country,
      rawLabel: "".concat(label, " ").concat((0, _phone.countryCodeOf)(country)),
      className: "flex-nowrap"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      className: "ic-intl-flag ic-intl-flag-".concat(country, " mg-r-3"),
      alt: ""
    }), /*#__PURE__*/_react["default"].createElement("span", null, label), /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-muted text-nowrap"
    }, "\xA0+".concat((0, _phone.countryCodeOf)(country))));
  })), /*#__PURE__*/_react["default"].createElement(_MenuEmpty["default"], null, i18n('react-ui.menu.empty.label'))));
};
var _default = exports["default"] = (0, _compose["default"])(_react["default"].memo, _react["default"].forwardRef)(FlagSelector);